import './utils/lite-youtube-embed'

import './style/styles-edito-map.scss'

import { createComponent } from '@bigyouth/base'
import * as features from './features/exports/edito-map'

Object.values(features).forEach(createComponent)
